import { render, staticRenderFns } from "./UiVaultCategoryStats.vue?vue&type=template&id=1f287eae&"
import script from "./UiVaultCategoryStats.vue?vue&type=script&lang=js&"
export * from "./UiVaultCategoryStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports